<template>
  <div>
    <b-form @submit.prevent="submit" novalidate>
      <div class="row">
        <div class="col-6">
          <div class="data-list">
            <dl>
              <dt>KMKR</dt>
              <dd v-if="client.vatin">
                <validated-form-select name="vatin" :options="parsedVatins"
                                       v-model="vatin" validate="required" :validator="$validator"/>
              </dd>
            </dl>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <submit-button class="float-right" variant="primary">Kinnita KMKR vahetus</submit-button>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
  import gateway from '@/services/gateway'
  import ValidatedFormSelect from '@/components/ValidatedFormSelect'

  export default {
    components: { ValidatedFormSelect },
    props: ['invoice'],
    data() {
      return {
        client: Object.assign({vatin: null}, this.invoice.client),
        vatin: this.invoice.vatin
      }
    },
    mounted() {
      this.loadClient()
    },
    methods: {
      loadClient() {
        gateway.get('/clients/' + this.client.id).then(r =>
          Object.assign(this.client, {vatin: r.data.vatin})
        )
      },

      submit() {
        gateway
          .post(`/invoices/${this.invoice.id}/change-vatin`, {vatin: this.vatin})
          .then(() => {
            this.$notifications.info(`Arve saaja KMKR on vahetatud. Uus KMKR on ${this.vatin}`)
            this.$emit('done')
          })
      }
    },
    computed: {
      parsedVatins: function() {
        if (!this.client.vatin) return []

        return this.client.vatin.split(',')
          .map(v => v.trim())
          .filter(v => v.length > 0)
          .map(v => { return {value:v,text:v} } )
      }
    }
  }
</script>
